const SectionHeader = ({ background, foreground }) => {
  return (
    <div className="relative text-center mb-12">
      {/* Background text */}
      <h2 className="text-outline text-7xl md:text-9xl font-extrabold font-bebas uppercase absolute inset-0 flex items-center justify-center opacity-20 pointer-events-none">
        {background}
      </h2>

      {/* Foreground text */}
      <p className="relative text-2xl md:text-4xl font-extrabold text-primary-950 mt-8 uppercase tracking-wide">
        {foreground}
      </p>
    </div>
  );
};

export default SectionHeader;
